import colors from '../../constants/colors'

const tabsStyle = {
  color: colors.BLACK,
  minHeight: '0',
  '& .MuiButtonBase-root': {
    textTransform: 'none',
    padding: '.5rem',
    paddingX: {
      xs: '.6rem',
      lg: '.9rem',
      xl: '1.4rem',
    },
    minHeight: '0',
    minWidth: 'unset !important',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .Mui-selected': {
    backgroundColor: colors.TAG_LIGHT_BLUE,
    borderRadius: '.5rem',
    color: colors.BLACK,
  },
}

const tabsContainerStyle = {
  display: 'flex',
  flexGrow: 1,
  borderRight: `1px solid ${colors.TAG_LINES_GRAY}`,
  px: '3.6rem',
  py: { xs: '1rem', md: '2rem' },
  gap: '3rem',
}

const navItems = [
  {
    title: 'Report',
    href: '/cases/initialReport',
  },
  {
    title: 'Case Overview',
    href: '/cases/overview',
  },
  {
    title: 'Investigation',
    href: '/cases/investigation',
  },
  {
    title: 'Timeline',
    href: '/cases/timeline',
  },
  {
    title: 'Attachments',
    href: '/cases/attachments',
  },
  {
    title: 'Export Case',
    href: '/cases/export',
  },
  {
    title: 'Case Resolution',
    href: '/cases/resolve',
  },
  {
    title: 'Case Updates',
    href: '/cases/updates',
  },
  // {
  //   title: 'Inbox', // ✅ Add this
  //   href: '/cases/inbox',
  // },
]

export default {
  navItems,
  tabsContainerStyle,
  tabsStyle,
}
